import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import { FormProvider } from 'context/FormContext';
import FloatingActionButton from 'components/Shared/FloatingActionButton';
import ContactsGrid from 'components/Contacts/Grid';
import AuthCheck from 'components/Shared/AuthCheck';
import { useAuthContext } from 'hooks/useAuthContext';
import AddContactScreen from './AddContactScreen';
import ContactForm from 'components/Contacts/ContactForm';

const tabs = [
  new Tab({ label: "Assigned", value: "Assigned" }),
  new Tab({ label: "Create", value: "Create", scope: "Contacts", action: "create"})
]

const Contacts = () => {
  const [activeTab, setActiveTab] = useState("Assigned");
  const { role } = useAuthContext();

  return (
    <FormProvider>
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >

      {activeTab === "Assigned" ? <ContactsGrid /> : <AddContactScreen setActiveTab={setActiveTab} FormComponent={ContactForm} entityName="Contact" />}

      <AuthCheck role= {role} scope="Contacts" action="create">
        <FloatingActionButton onClick={() => setActiveTab("Create")}><AddIcon /></FloatingActionButton>
      </AuthCheck>

    </TabbedPage>
    </FormProvider>
  )
}

export default Contacts;